<template>
    <div class="container">
        <table border="1" class="table" v-loading="loading">
            <tr>
                <th colspan="7">
                    <a-row>
                        <a-col :span="12"><a-date-picker v-model:value="date" valueFormat="YYYY-MM-DD" @change="loadtable"
                                :disabledDate="disabledDate" /></a-col>
                        <a-col :span="12">{{ nowtime }}</a-col>
                    </a-row>
                </th>
            </tr>
            <tr>
                <th>时间</th>
                <th>成功</th>
                <th>失败</th>
                <th>剩余</th>
                <th>任务数</th>
                <th>成功率</th>
                <th>完成率</th>
       
            </tr>
            <tr>
                <td>当天</td>
                <td>{{ dto.success }}</td>
                <td>{{ dto.fail }}</td>
                <td>{{ dto.no_complete_all }}</td>
                <td>{{ dto.total }}</td>
                <td>{{ dto.percent_success }}%</td>
                <td>{{ dto.percent_complete }}%</td>
          
            </tr>
            <tr v-for="row in dto.list">
                <td>{{ row.time }}</td>
                <td>{{ row.success }}</td>
                <td>{{ row.fail }}</td>
                <!-- <td colspan="3"></td> -->
            </tr>
            <!-- <tr >
                <td colspan="7">以往剩余任务：{{dto.no_complete_all}}</td>
            </tr> -->
        </table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dto: {
                time: '',
                success: 0,
                fail: 0,
                total: 0,
                percent_success: 0,
                percent_complete: 0,
                list: []
            },
            columns: [{
                title: '时间',
                dataIndex: 'time',
                key: 'time',
            }],
            nowtime: '',
            date: '',
            loading: true
        }

    },
    created() {
        this.date = this.$moment().format("YYYY-MM-DD");
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            this.$get("/video/admin_video_process", {
                date: this.date
            }).then((res) => {
                this.dto = res.data;
                this.nowtime = res.data.time;
                this.loading = false;
            });
        },
        disabledDate(current) {
            return current && current > this.$moment();
        }

    }

}
</script>
<style scoped>
.container {
    background: #fff;
    padding-top: 10%;
    height: calc(100vh);
    margin: auto;
}

.table {
    margin: auto;
    text-align: center;
}

.table tr:first-child {
    line-height: 32px;
}

.table td {
    width: 80px;
}
</style>